import { FormControlLabel, MenuItem, Radio } from "@mui/material";
import { useState } from "react";
import ConfirmDialog from "../../../commons/dialog/confirmDialog";
import FormikActions from "../../../commons/formik/formikActions";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import FormikCheckbox from "../../../commons/formik/formikCheckbox";
import FormikDatePicker from "../../../commons/formik/formikDatePicker";
import FormikDateTimePicker from "../../../commons/formik/formikDateTimePicker";
import FormikForm from "../../../commons/formik/formikForm";
import FormikRadio from "../../../commons/formik/formikRadio";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextField from "../../../commons/formik/formikTextField";
import FormikTextFieldSpeech from "../../../commons/formik/formikTextFieldSpeech";
import { StyledCommonForms } from "../../../styled/form";
import AppointmentControl from "../appointmentControl/appointmentControl";
import DiagnosisControlContainer from "../diagnosisControl/diagnosisControlContainer";
import DropZone from "../dropZone/dropZone";
import FormSectionDivider from "../formSectionDivider";
import { iamiValidation, validateRequiredFields } from "../formValidation";
import ProfessionalControl from "../professionalControl/professionalControl";

const Iami = ({
  handleClose,
  files,
  setFiles,
  handleSubmit,
  model,
  formValues,
  selectedDocument,
  openAppointment,
  handleAppointmentSubmit,
  handleCloseAppointment,
  handleOpenAppointment,
  appointmentModel,
  isView,
  disabled,
  idArt,
  lastProfessionalInfo
}) => {
  const [professionalError, setProfessionalError] = useState(false);
  const [attachmentError, setAttachmentError] = useState(false);
  const [openMissingNextAppointDialog, setOpenMissingNextAppointDialog] = useState(false);

  const fields = model.fields;
  const fechaPrimeraCuracionMinDate =
    fields?.fechaPrimeraCuracion?.validations?.minDate ?? undefined;
  return (
    <FormikForm
      artFields={fields}
      initialValues={formValues}
      validationSchema={() =>
        iamiValidation(fechaPrimeraCuracionMinDate, isView)
      }
      validate={(values) => {
        const errors = validateRequiredFields(values, fields)
        if (model.configuration.requiresAttachment && files.length === 0) {
          errors.attachment = "Adjunto requerido";
          setAttachmentError(true);
        }
        return errors;
      }}
      onSubmit={(values) => {
        if (!professionalError) {
          if (!values.fechaHoraProximaConsulta) {
            setOpenMissingNextAppointDialog(true);
            return;
          }
          handleSubmit(values);
        }
      }}>
      {({ values, setFieldValue }) => (
        <StyledCommonForms.FormContainer>

          <StyledCommonForms.FieldContainer>
            <FormSectionDivider title="Accidente" />
            {model.configuration.showTypeFormCombo && (
              <StyledCommonForms.RowContainer>
                <FormikSelect
                  name="nombreTipoFormulario"
                  label={`Tipo de Formulario Especifico ${fields.nombreTipoFormulario.required ? "*" : ""
                    }`}
                  value={formValues.nombreTipoFormulario}
                  variant="outlined"
                  sx={StyledCommonForms.input}
                  disabled={disabled}>
                  {fields.tiposFormulario.options.map((f) => {
                    return (
                      <MenuItem key={f.nombre} value={f.nombre}>
                        {f.formulario} - {f.nombre}
                      </MenuItem>
                    );
                  })}
                </FormikSelect>
              </StyledCommonForms.RowContainer>
            )}
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikSelect
                  name="tipoSiniestro"
                  value={formValues.tipoSiniestro}
                  label={`Tipo de Siniestro ${fields.tipoSiniestro.required ? "*" : ""
                    }`}
                  variant="outlined"
                  sx={StyledCommonForms.input}
                  disabled={disabled}>
                  {fields.tipoSiniestro.options?.list?.map((ts) => (
                    <MenuItem value={ts.nombre} key={ts.id}>
                      {ts.nombre}
                    </MenuItem>
                  ))}
                </FormikSelect>
              </StyledCommonForms.LeftColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikDateTimePicker
                  name="fechaHoraAccidente"
                  label={`Fecha Hora Accidente ${fields.fechaHoraAccidente.required ? "*" : ""
                    }`}
                  disableFuture
                  sx={StyledCommonForms.input}
                  disabled={disabled}
                  autoComplete="off"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <FormikDatePicker
                  name="fechaHoraAbondonoTrabajo"
                  label={`Fecha en que abandonó el Trabajo ${fields.fechaHoraAbondonoTrabajo.required ? "*" : ""
                    }`}
                  variant="outlined"
                  disableFuture
                  sx={StyledCommonForms.input}
                  disabled={disabled}
                  autoComplete="off"
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikDateTimePicker
                  name="fechaPrimeraCuracion"
                  label={`Fecha Primera Curación ${fields.fechaPrimeraCuracion.required ? "*" : ""
                    }`}
                  inputVariant="outlined"
                  disableFuture
                  minDate={fechaPrimeraCuracionMinDate}
                  sx={StyledCommonForms.input}
                  disabled={disabled || isView}
                  autoComplete="off"
                />
              </StyledCommonForms.LeftColumnContainer>
              <StyledCommonForms.RightColumnContainer>
                <AppointmentControl
                  addAppointmentControl={
                    model.configuration.addAppointmentControl
                  }
                  appointmentModel={appointmentModel}
                  artFields={fields}
                  name="fechaHoraProximaConsulta"
                  handleAppointmentSubmit={handleAppointmentSubmit}
                  openAppointment={openAppointment}
                  handleOpenAppointment={handleOpenAppointment}
                  handleCloseAppointment={handleCloseAppointment}
                  especialidadesProfesional={fields.especialidadProfesional}
                  required={fields.fechaHoraProximaConsulta.required}
                  disabled={
                    disabled ||
                    (isView &&
                      (!fields.fechaHoraProximaConsulta.required ||
                        formValues.fechaHoraProximaConsulta))
                  }
                  idArt={idArt}
                  preloadedProfessional={values.profesionalApellidoNombre || lastProfessionalInfo.profesionalApellidoNombre}
                  preloadedMnMd={values.profesionalMnMp || lastProfessionalInfo.matricula}
                  preloadedSpecialty={values.especialidadInforme || lastProfessionalInfo.especialidadInforme}
                />
              </StyledCommonForms.RightColumnContainer>
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikTextFieldSpeech
                id="comoOcurrioAccidente"
                name="comoOcurrioAccidente"
                label={`¿Cómo ocurrió el accidente? ${fields.comoOcurrioAccidente.required ? "*" : ""
                  }`}
                type="text"
                variant="outlined"
                multiline
                minRows={3}

                sx={StyledCommonForms.input}
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikAutocomplete
                name="formaAccidente"
                label={`Forma del Accidente ${fields.formaAccidente.required ? "*" : ""
                  }`}
                variant="outlined"
                options={fields.formaAccidente.options}
                sx={StyledCommonForms.input}
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikAutocomplete
                name="agenteCausante"
                label={`Agente Material ${fields.agenteCausante.required ? "*" : ""
                  }`}
                variant="outlined"
                options={fields.agenteCausante.options}
                sx={StyledCommonForms.input}
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikTextFieldSpeech
                id="tratamiento"
                name="tratamiento"
                label={`Tratamiento ${fields.tratamiento.required ? "*" : ""}`}
                type="text"
                multiline
                minRows={3}

                variant="outlined"
                sx={StyledCommonForms.input}
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikCheckbox
                  name="reagravacion"
                  label={`Reagravación ${fields.reagravacion.required ? "*" : ""
                    }`}
                  labelPlacement="end"
                  disabled={disabled}
                />
              </StyledCommonForms.LeftColumnContainer>
              {values.reagravacion && (
                <StyledCommonForms.RightColumnContainer>
                  <FormikAutocomplete
                    name="tipoReingreso"
                    label={`Tipo de Reingreso ${values.reagravacion ? "*" : ""
                      }`}
                    variant="outlined"
                    options={fields.tipoReingreso.options}
                    sx={StyledCommonForms.input}
                    disabled={disabled}
                  />
                </StyledCommonForms.RightColumnContainer>
              )}
            </StyledCommonForms.RowContainer>
            {values.reagravacion && (
              <StyledCommonForms.RowContainer>
                <StyledCommonForms.LeftColumnContainer>
                  <FormikDatePicker
                    name="fechaReagravacion"
                    label={`Fecha de Reagravación ${values.reagravacion ? "*" : ""
                      }`}
                    inputVariant="outlined"
                    sx={StyledCommonForms.input}
                    disabled={disabled}
                    autoComplete="off"
                  />
                </StyledCommonForms.LeftColumnContainer>
                <StyledCommonForms.RightColumnContainer>
                  <FormikDatePicker
                    name="fechaAtencionReagravacion"
                    label={`Fecha Atención Reagravación ${values.reagravacion ? "*" : ""
                      }`}
                    inputVariant="outlined"
                    sx={StyledCommonForms.input}
                    disabled={disabled}
                    autoComplete="off"
                  />
                </StyledCommonForms.RightColumnContainer>
              </StyledCommonForms.RowContainer>
            )}
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikCheckbox
                  name="atencionMedicaAnterior"
                  label={`Atención Médica Anterior ${fields.atencionMedicaAnterior.required ? "*" : ""
                    }`}
                  labelPlacement="end"
                  disabled={disabled}
                />
              </StyledCommonForms.LeftColumnContainer>
              {values.atencionMedicaAnterior && (
                <StyledCommonForms.RightColumnContainer>
                  <FormikTextField
                    name="centroAsistencial"
                    label={`Centro Asistencial ${fields.centroAsistencial.required ? "*" : ""
                      }`}
                    type="text"
                    variant="outlined"
                    sx={StyledCommonForms.input}
                    disabled={disabled}
                  />
                </StyledCommonForms.RightColumnContainer>
              )}
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikCheckbox
                  name="bajaLaboral"
                  label={`Baja Laboral ${fields.bajaLaboral.required ? "*" : ""
                    }`}
                  labelPlacement="end"
                  disabled={disabled}
                />
              </StyledCommonForms.LeftColumnContainer>
              {values.bajaLaboral && (
                <StyledCommonForms.RightColumnContainer>
                  <FormikTextField
                    name="diasEstimados"
                    label={`Días Estimados ${fields.diasEstimados.required ? "*" : ""
                      }`}
                    type="number"
                    variant="outlined"
                    sx={StyledCommonForms.input}
                    disabled={disabled}
                  />
                </StyledCommonForms.RightColumnContainer>
              )}
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <StyledCommonForms.LeftColumnContainer>
                <FormikCheckbox
                  name="sugerenciaRechazo"
                  label={`Sugerencia Rechazo ${fields.sugerenciaRechazo.required ? "*" : ""
                    }`}
                  labelPlacement="end"
                  disabled={disabled}
                />
              </StyledCommonForms.LeftColumnContainer>
              {values.sugerenciaRechazo && (
                <StyledCommonForms.RightColumnContainer>
                  <FormikSelect
                    name="causaRechazo"
                    value={formValues.causaRechazo}
                    label={`Causa Rechazo ${fields.causaRechazo.required ? "*" : ""
                      }`}
                    variant="outlined"
                    sx={StyledCommonForms.input}
                    disabled={disabled}>
                    {fields.causaRechazo.options.map((cr) => (
                      <MenuItem value={cr} key={cr}>
                        {cr}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </StyledCommonForms.RightColumnContainer>
              )}
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikCheckbox
                name="suponeIncapacidad"
                label={`Supone Incapacidad ${fields.suponeIncapacidad.required ? "*" : ""
                  }`}
                labelPlacement="end"
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikCheckbox
                name="r79"
                label={`¿Se encuadra dentro de los accidentes de la Res. 1021/2008 de la S.R.T.? ${fields.r79.required ? "*" : ""
                  }`}
                labelPlacement="end"
                disabled={disabled}
              />
            </StyledCommonForms.RowContainer>
            <StyledCommonForms.RowContainer>
              <FormikRadio
                name="manoHabil"
                value={formValues.manoHabil}
                label={`Mano Hábil ${fields.manoHabil.required ? "*" : ""}`}
                disabled={disabled}
                row>
                {fields.manoHabil.options.map((mh) => (
                  <FormControlLabel
                    value={mh}
                    control={<Radio />}
                    label={mh}
                    labelPlacement="end"
                    key={mh}
                  />
                ))}
              </FormikRadio>
            </StyledCommonForms.RowContainer>
            <FormSectionDivider title="Diagnóstico" />
            <DiagnosisControlContainer
              idArt={idArt}
              fields={fields}
              disabled={disabled}
              showGravedad
              showDescripcionDiagnostico
            />
            <FormSectionDivider title="Profesional" />
            <ProfessionalControl
              disabled={disabled}
              fields={fields}
              setFieldValue={setFieldValue}
              profesionalPreCarga={formValues.profesionalApellidoNombre}
              error={professionalError}
              setError={setProfessionalError}
              especialidadesProfesional={fields.especialidadProfesional}
              values={values}
              habilitarEspecialidadInforme={true}
              isView={isView}
              idArt={idArt}
            />

            {model.configuration.showAttachments && (
              <div>
                <FormSectionDivider title="Adjuntos" />
                <StyledCommonForms.RowContainer>
                  <DropZone
                    files={files}
                    setFiles={setFiles}
                    configuration={model.configuration}
                    error={attachmentError}
                    setError={setAttachmentError}
                    disabled={disabled}
                    selectedDocument={selectedDocument}
                    accept={model.configuration.availableExtensions}
                  />
                </StyledCommonForms.RowContainer>
              </div>
            )}
          </StyledCommonForms.FieldContainer>
          <StyledCommonForms.ActionsContainer>
            <FormikActions handleCancel={handleClose} disabled={disabled} />
          </StyledCommonForms.ActionsContainer>
          <ConfirmDialog
            handleClose={() => handleSubmit(values)}
            handleConfirm={() => {
              setOpenMissingNextAppointDialog(false);
              handleOpenAppointment();
            }}
            open={openMissingNextAppointDialog}
            cancelText="Guardar y Finalizar"
            confirmText="Guardar y Continuar"
            title={"Fecha de Próxima Consulta"}
            text={"Se detectó que no ha asignado una Fecha de Próxima Consulta. ¿Desea agregarla antes de guardar el formulario?"}
          />
        </StyledCommonForms.FormContainer>
      )}
    </FormikForm>
  );
};

export default Iami;
